import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import OrderDownload from './Components/OrderCheckout/OrderDownload';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';
import BasketContextProvider from './Components/Context/BasketContext';

function OrderDownloadRoute() {
    return (
        <UserInfoProvider>
            <BasketContextProvider>
                <MedicalContextProvider>
                    <div className="OrderDownloadRoutePage">
                        <div className="OrderDownloadRouteNavBar">      
                            <NavBar/>
                        </div>
                        <div className="OrderDownloadRoute">
                            <OrderDownload/>
                        </div>
                        {/*<div className="OrderDownloadRouteFooter">      
                            <Footer/>
                        </div>*/}
                    </div>
                </MedicalContextProvider>
            </BasketContextProvider>
        </UserInfoProvider>
    );
}

export default OrderDownloadRoute;